module.exports = __webpack_public_path__ + "f857a0fd.svg";